import React from 'react'
import { useLoginForm } from './useLoginForm'
import { LoginFormView } from './LoginFormView'

export const LoginForm: React.FC = () => {
  const props = useLoginForm()
  return <LoginFormView {...props} />
}
LoginForm.displayName = 'LoginForm'

export default LoginForm
